<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="My Attendance"
                :showAddNew="true"
                :btnTitle="'Add New'"
                @onClickAddNewButton="onClickAddNewButton"
            />
        </div>
        <div class="my-2 px-2">
            <DateQuerySetter
                btnTitle="Go"
                @onClickGo="onClickToGo"
                class="tds-vds-query-setter"
            >
            </DateQuerySetter>
        </div>

        <div class="col-12 px-2 mt-2 mb-4">
            <ListTable :tableItems="tableItems" :formData="formData" :getAttendanceList="getAttendanceList" />
        </div>

        <Loader v-if="loading"/>

      <ManualAttendanceModal
          v-if="store.state.isModalOpenTwo"
          :formData="formData"
          @getAttendanceList="getAttendanceList"
      />

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import ListTable from '@/components/molecule/company/hrm-payroll/my-attendance/ListTable.vue';
import ManualAttendanceModal from '@/components/molecule/company/hrm-payroll/my-attendance/ManualAttendanceModal.vue';
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import { computed } from 'vue';

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const params = ref({
    offset: 30,
});

const token = computed(() => localStorage.getItem('token'));

const {
  fetchAttendanceList,
} = handleHrPayroll()

const formData = ref({
  in_time:null,
  out_time:null,
  remarks:null,
  is_edit:false,
})

const onClickToGo = () => {
   getAttendanceList();
}

function onClickAddNewButton() {
  store.state.isModalOpenTwo = true
}

const getAttendanceList = async () => {
    const query = getQuery();
    loading.value = true
    tableItems.value = []

    await fetchAttendanceList(query).then(res => {
        if (!res.status){
            return
        }

        tableItems.value = res.data;
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (route.query.page) query += '&page=' + route.query.page;
    if (route.query.start) query += '&start_date=' + route.query.start;
    if (route.query.end) query += '&end_date=' + route.query.end;
    query += '&offset=' + params.value.offset
    return query;
}

onMounted(() => {
    Promise.all([
         getAttendanceList(),
    ])
})
</script>
